/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { LoraConfig } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class LoraConfigConverter implements BodyConverter<LoraConfig> {
  public encode(
    model: LoraConfig,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeLoraConfig(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): LoraConfig {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readLoraConfig();
  }
}
